<template>
  <div>
    <b-modal
      centered
      ref="dialogWait"
      no-close-on-backdrop
      no-close-on-esc
      size="sm"
      hide-header
      hide-footer
    >
      <div class="center-xs">
        <spinner />
      </div>
      <div class="center-xs pt-3">
        {{ currentLoadingMessage }}
      </div>
    </b-modal>

 
    <div
      v-if="canEdit"
      class="w-100 d-flex flex-wrap align-items-center"
      :class="`${
        !isDevelopment ? 'justify-content-end' : 'justify-content-between'
      }`"
    >
      <div
        v-if="isDevelopment"
        class="d-flex col-md-4 justify-content-start p-1"
      >
        <b-form-input
          v-model="rangeDays"
          placeholder="Coloque o máximo de dias"
          maxlength="360"
          size="sm"
          type="number"
          style="width: 100px"
          aria-describedby="laminaInput dapInputLiveFeedback"
          id="laminaInput"
          class="mr-2"
          state
        >
        </b-form-input>

        <b-button
          @click="generateTable"
          size="sm"
          class="mb-1 font-weight-regular btn-success"
          style="width: 120px; background-color: var(--submit-button-form)"
        >
          Buscar {{ rangeDays }} dias
        </b-button>
      </div>
      <div class="d-flex col-md-8 flex-wrap pl-2 pr-0 mr-0 justify-content-end">
        <div
          v-if="isDevelopment"
          class="d-flex justify-content-end align-items-center"
        >
          <b-button
            @click="$refs.dataTable ? $refs.dataTable.importJSON() : ''"
            size="sm"
            variant="outline-secondary"
            class="m-1 mb-1 font-weight-regular"
            style="max-width: 150px"
          >
            <upload-icon style="font-size: 1.1em; vertical-align: -3%" />
            Importar Configuração
          </b-button>

          <b-button
            class="align-items-center font-weight-regular"
            :class="showDownloadOptions ? null : 'collapsed'"
            size="sm"
            style="max-width: 100px"
            id="downloads-options"
            variant="outline-secondary"
            :aria-expanded="showDownloadOptions ? 'true' : 'false'"
            aria-controls="collapse-downloads"
            @click="showDownloadOptions = !showDownloadOptions"
          >
            Baixar Planilha
          </b-button>
          <b-collapse
            id="collapse-downloads"
            v-model="showDownloadOptions"
            class="mt-1 download-options"
          >
            <download-table-content
              :show-options="['json']"
              :downloadCSV="$refs.dataTable ? $refs.dataTable.downloadCSV : ''"
              :downloadXLSX="
                $refs.dataTable ? $refs.dataTable.downloadXLSX : ''
              "
              :downloadPDF="$refs.dataTable ? $refs.dataTable.downloadPDF : ''"
              :downloadJSON="
                $refs.dataTable ? $refs.dataTable.downloadJSON : ''
              "
              class="py-2 py-lg-2"
            />
          </b-collapse>
        </div>
        <b-btn 
          :disabled = "hasEmptyCol"
          :variant="!hasEmptyCol ? '3v3' : ''"
          @click="generateMangement"
          size="sm"
          variant="outline-secondary"
          class="col-md-12 justify-content-end saveButton m-1 mb-1 font-weight-regular"
          style="max-width: 150px"
        >
          Salvar dados e recalcular manejo
        </b-btn>
      </div>
    </div>

    <data-table
      ref="dataTable"
      sticky-header
      class="flex-grow-1"
      max-height-table="100%"
      :left-frozen-columns="leftFrozenColumns"
      :static-columns="staticColumns"
      :table-data="stationData"
      @update-table-data="updateTableData"
      :file-prefix="`ET0_MANEJO_${startingDateTable}_${endingDateTable}`"
    />
  </div>
</template>

<script>
import { monit } from "@/api";
import moment from "moment";
import DataTable from "@/pages/components/shared/table/DataTable.vue";
import { management } from "@/api";
import managementSectorsActions from "@/mixins/managementSectorActions.js";
import DownloadTableContent from "@/pages/components/shared/table/DownloadTableContent.vue";
export default {
  components: {
    DataTable,
    DownloadTableContent,
  },
  mixins: [managementSectorsActions],
  data() {
    return {
      hasStation: true,
      rangeDays: 15,
      showDownloadOptions: false,
      loadingMessages: {
        sectors: "Carregando setores de manejo...",
        volumes: "Calculando volumes de válvulas...",
        savingTable: "Salvando dados de ET0 e precipitação inseridos...",
        management: "Fazendo o cálculo de manejo de todos os setores...",
      },
      currentLoadingMessage: "",
      validTable: false,
      loading: false,
      items: [],
      itemsUnchanged: [],
      timeRangeForm: {},
      leftFrozenColumns: [
        {
          title: "Dia",
          field: "time",
          minWidth: 120,
          formatter: (cell) => moment(cell.getValue()).format("DD/MM/YYYY"),
          accessorDownload: (val) => moment(val).format("DD/MM/YYYY"),
        },
      ],
    };
  },
  watch: {
    loading: {
      handler(newValue) {
        if (newValue) {
          this.$refs.dialogWait.show();
        } else {
          this.$refs.dialogWait.hide();
        }
      },
    },
    hasStation: {
      handler(newValue) {
        if (newValue) {
          alert(
            "Fazenda possui estação, não há necessidade de alterar dados de estação",
            "w"
          );

          // return this.$router.push("/registers");
        } else {
          this.$refs.dialogWait.hide();
        }
      },
    },
  },
  computed: {
    staticColumns() {
      return [
        {
          title: "Et0",
          field: "et0_value",
          minWidth: 90,
          accessorDownload: (val) => (val === null ? "indefinido" : val),
          editor: "number",
          editable:
            !this.hasStation && this.isForgottenOrYesterday && this.canEdit,
        },
        {
          title: "Precipitação",
          field: "rainfall_value",
          minWidth: 90,
          formatter: (cell) => cell.getValue(),
          accessorDownload: (val) => val,
          editor: "number",
          editable:
            !this.hasStation && this.isForgottenOrYesterday && this.canEdit,
        },
      ];
    },
    canEdit() {
      return (!this.hasStation || this.isDevelopment) && !this.loading;
    },
    stationData() {
      return this.items.slice(0, this.rangeDays);
    },
    isDevelopment() {
      return process.env.NODE_ENV == "development";
    },
    startingDateTable() {
      return this.items.length && this.items[0].time;
    },
    endingDateTable() {
      return this.items.length && this.items[this.items.length - 1].time;
    },
    hasEmptyCol() {
      return this.items.some((row) => {
        const et0 = row.et0_value;
        const rainfall = row.rainfall_value;
        return (
          (!et0 && et0 !== "0" && et0 !== 0) ||
          (!rainfall && rainfall !== "0" && rainfall !== 0)
        );
      });
    },
  },
  async created() {
    try {
      this.$emit("title-change", "Estação Manual");
      this.hasStation = (await monit.station()).status;

      window.onclick = (event) => {
        if (
          event.target.id != "collapse-downloads" &&
          event.target.id != "downloads-options" &&
          this.showDownloadOptions
        ) {
          this.showDownloadOptions = false;
        }
      };
      await this.generateTable();
    } catch (e) {
      alert("Ocorreu um erro ao montar tabela", "e");
    }
  },
  methods: {
    isForgottenOrYesterday(cell) {
      const rowData = cell.getData();
      const yesterday = moment().subtract(1, "days").format("YYYY-MM-DD");
      const isYesterday = rowData.time == yesterday;
      const isDayForgotten = !rowData.date_saved_db;
      return isYesterday || isDayForgotten;
    },
    async getFirstEt0Day() {
      const raw = `
        SELECT MIN((FIRST_ET0.TIME)) TIME
        FROM CROP.ET0 FIRST_ET0;
      `;
      const first_et0_day = await management
        .sql({
          data: {
            sql: raw,
          },
        })
        .then((resp) => (resp[0] && resp[0].length ? resp[0][0] : {}))
        .catch((err) => {
          console.log(err);
          return {};
        });
      return first_et0_day && first_et0_day.TIME;
    },
    async saveTableInputs() {
      const rawDelete = (table) => `
        DELETE FROM CROP.${table}
        WHERE TIME BETWEEN '${this.startingDateTable}' AND '${this.endingDateTable}';
      `;
      const rawInsert = (table, key) => `
        INSERT INTO CROP.${table}
        (FK_STATION, TIME, VALUE)
        VALUES
          ${this.items
            .map((item) => {
              return `(230, '${item.time}', ${item[key]})`;
            })
            .join(",")}`;
      await Promise.all([
        management.sql({
          data: {
            sql: rawDelete("ET0"),
          },
        }),
        management.sql({
          data: {
            sql: rawDelete("RAINFALL"),
          },
        }),
      ]);
      await Promise.all([
        management.sql({
          data: {
            sql: rawInsert("ET0", "et0_value"),
          },
        }),
        management.sql({
          data: {
            sql: rawInsert("RAINFALL", "rainfall_value"),
          },
        }),
      ]);
    },

    async validateTableInputs() {
      try {
        this.validTable = false;
        if (this.hasEmptyCol) {
          return alert("Erro ao salvar tabela: Existem colunas vazias", "e");
        }
        this.loading = true;
        this.currentLoadingMessage = this.loadingMessages.savingTable;
        await this.saveTableInputs();
        this.itemsUnchanged = JSON.parse(JSON.stringify(this.items)).map(
          (item) => {
            item.date_saved_db = true;
            return item;
          }
        );
        this.items = JSON.parse(JSON.stringify(this.itemsUnchanged));
  
        this.validTable = true;

      } catch(e) {
        console.error("Erro ao validar tabela de estações")

      }
    },
    async generateMangement() {
      try {
        this.loading = true;

        await this.validateTableInputs();
        if (!this.validTable) {
          return;
        }
        this.currentLoadingMessage = this.loadingMessages.sectors;
        const managementSectors = await this.getManagementSectors({});

        this.currentLoadingMessage = this.loadingMessages.volumes;
        await this.calcVolumes();
        
        this.currentLoadingMessage = this.loadingMessages.management;
        await this.recalcSectorsManagement(managementSectors);
        
        this.loading = false;
        alert("Sucesso ao realizar calculo de manejo", "s");
      } catch (e) {
        alert("Erro ao realizar calculo de manejo");
        console.log(e);

        this.loading = false;
        this.items = JSON.parse(JSON.stringify(this.itemsUnchanged));
      }
    },
    isLoading(val) {
      this.$emit("loading", val);
    },
    async getValuesInTimeRange(start, end) {
      const raw = `
        SELECT
          ET0.FK_STATION,
          ET0.TIME,
          ET0.VALUE ET0_VALUE,
          RAINFALL.VALUE RAINFALL_VALUE
        FROM CROP.ET0 ET0
        LEFT JOIN CROP.RAINFALL RAINFALL
        ON RAINFALL.TIME = ET0.TIME
        WHERE ET0.TIME BETWEEN DATE('${start}') AND DATE('${end}')
        ORDER BY ET0.TIME ASC;
      `;
      return await management
        .sql({
          data: {
            sql: raw,
          },
        })
        .then((resp) => resp[0])
        .catch((err) => {
          console.log(err);
          return [];
        });
    },
    updateTableData(val) {
      this.items = val;
    },
    async generateTable() {
      this.isLoading(true);
      const firstEt0Day = await this.getFirstEt0Day();
      const yesterday = moment().subtract(1, "days").format("YYYY-MM-DD");
      let start;
      if (!firstEt0Day) {
        start = yesterday;
      } else if (moment(yesterday).diff(firstEt0Day, "days") >= 7) {
        start = moment()
          .subtract(this.rangeDays - 1, "days")
          .format("YYYY-MM-DD");
      } else {
        start = firstEt0Day;
      }
      const end = yesterday;
      const daysSaved = await this.getValuesInTimeRange(start, end);

      this.items = this.generateArrayOfTimeRange(start, end).map((row) => {
        const rowInDatabase = daysSaved.find(
          (et0Data) => et0Data.TIME == row.time
        );
        if (rowInDatabase) {
          row.et0_value = rowInDatabase.ET0_VALUE;
          row.rainfall_value = rowInDatabase.RAINFALL_VALUE;
          row.date_saved_db = true;
        } else {
          row.et0_value = null;
          row.rainfall_value = null;
        }
        return row;
      });

      this.isLoading(false);
      this.itemsUnchanged = JSON.parse(JSON.stringify(this.items));
    },
    generateArrayOfTimeRange(start, end) {
      const diffDays = moment(end).diff(start, "days") + 1;
      return [...Array(diffDays).keys()].map((item) => {
        return {
          time: moment(start).add(item, "days").format("YYYY-MM-DD"),
        };
      });
    },
  },
};
</script>

<style scoped>
.saveButton {
  background-color: var(--green-3v3);
  color: white;
}
.saveButton:hover {
  background-color: var(--submit-button-form-dark);
}
.download-options {
  position: absolute;
  background: white;
  padding: 5px;
  right: 0;
  z-index: 99;
  min-width: 10em;
  max-width: 15em;
  margin: 0 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.1s cubic-bezier(0.25, 0.8, 0.25, 1);
  border-radius: 4px;
}
</style>
